export interface TenantConfig {
  name: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  gradient?: string;
  menuBackground?: string;
  menuColor?: string;
}

export const trueLifeTenant: TenantConfig = {
  name: 'True Life Care',
  logo: '/true_life_care.png',
  primaryColor: '#0066CC',  // Main blue from their logo
  secondaryColor: '#003366', // Darker blue for accents
  gradient: '#FFFFFF'          // No gradient, clean look
};

export const congruityTenant: TenantConfig = {
  name: 'Congruity Health',
  logo: '/congruity_logo.png',
  primaryColor: '#003DA6',
  secondaryColor: '#0D3AF2',
  gradient: 'linear-gradient(90deg, #003DA6 0%, #07194a 100%)'
};

// Environment-based tenant configuration
export function getTenantConfig(): TenantConfig {
  const tenant = process.env.REACT_APP_TENANT?.toLowerCase();
  
  switch (tenant) {
    case 'truelife':
      return trueLifeTenant;
    case 'congruity':
      return congruityTenant;
    default:
      // Default to Congruity if no tenant is specified
      return congruityTenant;
  }
}